import { takeLatest, call, put } from 'redux-saga/effects';
import api from '../../api/index';
import {
  GET_FAQS, SET_FAQS, FAQS_REQUEST_FAILED, SENDING_FAQS_REQUEST,
} from '../../types/Types';

/**
 * Call the api and dispatch data to the reducer
 * @param { Object } action Contained object data to be send to API call
 */
export function* getFaqs(action) {
  const { data } = action;
  try {
    yield put({
      type: SENDING_FAQS_REQUEST,
      faqsData: '',
      isFaqsSending: true,
      isFaqsSuccess: false,
      faqsError: false,
    });
    const response = yield call(api.faqs, data);
    // console.log(response);
    if (response) {
      yield put({
        type: SET_FAQS,
        faqsData: response.toString(),
        isFaqsSending: false,
        faqsError: false,
        isFaqsSuccess: true,
      });
    } else {
      yield put({
        type: FAQS_REQUEST_FAILED,
        faqsData: null,
        isFaqsSending: false,
        faqsError: true,
        isFaqsSuccess: false,
        faqsMsg: response.errorMsg,
      });
    }
  } catch (e) {
    yield put({
      type: FAQS_REQUEST_FAILED,
      faqsMsg: e.message,
      isFaqsSending: false,
      faqsError: true,
      isFaqsSuccess: false,
      faqsData: null,
    });
  }
}

/**
 * map the dispatched action to the above function
 */
export default function* watchGetFaqs() {
  yield takeLatest(GET_FAQS, getFaqs);
}
